// Module
var code = "<p>URL Params can be all sorts of things, they could be a UTM parameter, Smart Seller, or something completely custom to your use case.</p> <p>Common params include: <code>utm-campaign</code>, <code>utm-medium</code>, <code>utm-source</code>, and <code>spid</code></p> ";
// Exports
export default code;